<template>
  <breadCrumbs title="Spinners" main="UI Kits" title1="Spinners" />
  <div class="container-fluid">
            <div class="row">
              <div class="col-sm-12 text-start">
                <div class="card">
                  <div class="card-header">
                    <h3>Loader Style</h3>
                  </div>
                  <div class="card-body row">
                      <loader/>
                      <loader2/>
                      <loader3/>
                  </div>
                </div>
              </div>
            </div>
              </div>
</template>
<script>
import loader from "./loaderPage.vue"
import loader2 from "./loader2Page.vue"
import loader3 from "./loader3Page.vue"
export default {
    components:{
        loader,
        loader2,
        loader3
    }
}
</script>